import { render, staticRenderFns } from "./DtCostumers.vue?vue&type=template&id=3327fc8d"
import script from "./DtCostumers.vue?vue&type=script&lang=js"
export * from "./DtCostumers.vue?vue&type=script&lang=js"
import style0 from "./DtCostumers.vue?vue&type=style&index=0&id=3327fc8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports